module.exports = __webpack_public_path__ + "img/Rectangle 1221 (1).f38e5cf6.png";